import { executeRequest, Request } from '@jfs/network'
import { AESEncryption, getRandomAlphaNumString, RSAEncryption } from '@jfs/utils'
import Config from 'react-native-config'
import { getNetworkResponseError, isStatusSuccess } from '../util/common'
import { isOsMobile } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigPreAuth } from './config'

const responseParser = (data: any) => {
  if (isStatusSuccess(data) || data?.data?.status === 'INITIATED') {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const otpLoginReq = (req: any, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfigPreAuth(tokens),
    apiPath: APIEndPoints.Login,
    method: 'POST',
    body: req,
  }
  return executeRequest(request)
    .then((data) => responseParser(data))
    .catch((error) => {
      throw error
    })
}

export const getSendOtpRequest = (mobileNumber) => {
  return {
    user: {
      mobile: {
        mobileNumber,
        countryCode: '91',
      },
    },
    scope: 'SESSION',
    authenticateList: [
      {
        mode: '46',
        action: 'generate',
      },
    ],
    purpose: 4,
    // entity: {
    //   groupId: '414190000000002',
    //   subGroupId: '414180000000002',
    // },
  }
}

export const getAuthenticateOtpRequest = (mobileNumber: string, otp: string) => {
  const { REACT_APP_PUBLIC_ENC_KEY } = isOsMobile() ? Config : window?._env_
  const PUBLIC_ENC_KEY: any = REACT_APP_PUBLIC_ENC_KEY
  console.log('PUBLIC_ENC_KEY', PUBLIC_ENC_KEY, mobileNumber, otp)
  let randomEncryptionKey = getRandomAlphaNumString(32)
  const encryptionKey = RSAEncryption(randomEncryptionKey, PUBLIC_ENC_KEY)
  let encOtp = AESEncryption(randomEncryptionKey, otp)

  return {
    user: {
      mobile: {
        mobileNumber,

        countryCode: '91',
      },
    },
    scope: 'SESSION',
    authenticateList: [
      {
        mode: '46',

        action: 'verify',

        value: encOtp,
      },
    ],
    purpose: 4,
    secure: {
      encryptionKey,
    },
    // entity: {
    //   groupId: '414190000000002',
    //   subGroupId: '414180000000002',
    // },
  }
}

export { otpLoginReq }
